import { map } from 'lodash';

// expects array of exams prescriptions template objects: [{id: 1, ...}, {id: 2, ...}, ...]
// => returns exams prescriptions template object: {1: {...}, 2: {...}, ...}
function normalizeExamsPrescriptionsTemplates (inputTemplates) {
  const templates = {};

  map(inputTemplates, (template) => {
    templates[template.id] = template;
  });

  return {
    examsPrescriptionTemplates: templates,
  };
}

export default {
  normalizeExamsPrescriptionsTemplates,
};
